import React, { Component } from "react";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import { Spin as AntdSpin } from "antd";

export default class Spin extends Component {
  render() {
    const { size } = this.props;
    let fontSize = 24;
    if (size === "small") {
      fontSize -= 7;
    }
    if (size === "large") {
      fontSize += 7;
    }
    const antIcon = <LoadingOutlined style={{ fontSize }} spin />;

    return <AntdSpin indicator={antIcon} {...this.props} />;
  }
}
